import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { deleteOrRule, addOrRule, updateOrRule } from '@store/errorLogicConfig/configContainer/actions';
import { ConfigOperator } from '../Common/utils';
import { RowLabel } from '../styled';
import { Button, Form, Input, Space, Select } from 'antd';

interface IProps {
  key: string;
  lookup: string;
  rule: {
    operator: string,
    value: string
  };
  canDel?: boolean;
}

function FilterRow({
  //   key,
  lookup,
  rule,
  canDel,
}: IProps) {
  const dispatch = useDispatch();
  const itemList = ConfigOperator();
  const { operator } = rule;
  const { value } = rule;
  const text = itemList.filter(op => op.key === operator);

  const onChange = (e) => {
    dispatch(updateOrRule(lookup, { value: e.target.value }));
  };

  const onOpChange = (op) => {
    dispatch(updateOrRule(lookup, { operator: `${op}` }));
  };

  const onClickDel = (e) => {
    dispatch(deleteOrRule(lookup));
  };

  const onClickOR = (e) => {
    dispatch(addOrRule(lookup));
  };

  return (
    <Space align='center' size='middle'>
      <RowLabel> Error </RowLabel>

      <Form.Item label="Operator" required style={{ width: '100px', paddingBottom: 0 }}>
        <Select
          value={operator}
          options={itemList}
          onChange={onOpChange}
        />
      </Form.Item>

      <Form.Item label="Value" required style={{ paddingBottom: 0 }}>
        <Input type="text" value={value} onChange={onChange} />
      </Form.Item>

      <Button key="add-or-rule" onClick={onClickOR}>
        OR
      </Button>
      {canDel ? (
        <Button key="del-row" onClick={onClickDel}>
          <CloseOutlined />
        </Button>
      ) : null}
    </Space>
  );
}

export default FilterRow;
